/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  HeroSectionService,
  IHeroSectionMethods,
  LoadingService,
  ILoadingMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  AttributesService,
  IAttributesMethods,
  CarouselService,
  ICarouselMethods,
  DescriptionService,
  IDescriptionMethods,
  CredentialService,
  ICredentialMethods,
  ListItemService,
  ILisItemMethods,
  NFCService,
  INFCServiceMethods,
} from "./components";

export type IssuedCredentialPageAgent = IHeaderMethods &
  IHeroSectionMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IAttributesMethods &
  ICarouselMethods &
  IDescriptionMethods &
  ICredentialMethods &
  ILisItemMethods &
  INFCServiceMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new HeroSectionService(),
    new CarouselService(),
    new LoadingService(),
    new StaticPageContentService(),
    new AttributesService(),
    new DescriptionService(),
    new CredentialService(),
    new ListItemService(),
    new NFCService(),
  ];
};

export const getAgent = () => {
  return createAgent<IssuedCredentialPageAgent>({
    plugins: getPlugins(),
  });
};
